export function generateGuid(prepend_text = '') {
    return prepend_text + randomNumber(10000) + (Date.now());
}

export function randomNumber(max = 1) {
    return Math.floor((Math.random() * max));
}

export function copyTextToClipboard(text) {
    navigator.clipboard.writeText(text).then();
}

export function showSpinner(loading_message = 'Loading...') {
    $("#loading-spinner .loading-message").html(loading_message);
    $("#loading-spinner").show();

    maggieland.spinner_click_counter = 0;
}

export function hideSpinner() {
    $("#loading-spinner").hide();

    maggieland.spinner_click_counter = 0;
}

export function isNull(value) {
    return value === null || value === undefined;
}